import { computed, ref, toValue, watch } from 'vue';
import { getSportLiveTvEventLogos } from '@/sport-live-tv/helpers';

export const useSportLiveTvLogo = (event) => {
  const failedCount = ref(0);

  const candidates = computed(() => getSportLiveTvEventLogos(toValue(event)));
  const src = computed(() => candidates.value[failedCount.value]);

  const handleError = () => {
    failedCount.value++;
  };

  watch(candidates, () => {
    failedCount.value = 0;
  });

  return { src, handleError };
};
